import { config } from '../../../../../config/config.json';

export const MAX_FILE_SIZE = 50 * 1024 * 1024;
export const MAX_NUMBER_OF_FILES = 10;

export const ACCEPTED_FILE_EXTENSIONS = ['.pdf', '.doc', '.docx'];

export const ACCEPTED_MIME_TYPES = [
  config.files.extensionToMimeType['.pdf'],
  config.files.extensionToMimeType['.doc'],
  config.files.extensionToMimeType['.docx'],
];

export const ERROR_DISPLAY_DELAY = 100;

export const TOPICS_CSV_DOWNLOAD_HELP_ARTICLE = `${config.helpLink}/article/ART-0000`; // TODO: update with real article link once available
